import { useInvitations } from '../hooks/useInvitations';
import { useAssessments } from '@/features/assessments/hooks/useAssessments';
import { RoleType, AssessmentStatus } from '@promo/shared';

export function useBlindAssessmentProgress(packetId: string, canViewAssessments: boolean = true) {
  // Fetch invitations for assessors
  const { data: assessorInvitations = [], isLoading: isInvitationsLoading, error: invitationsError } = useInvitations(
    packetId,
    RoleType.ASSESSOR,
    { enabled: !!packetId }
  );
  const invitedCount = assessorInvitations.length;

  // Fetch blinded assessments
  const { blinded = [], isLoading: isAssessmentsLoading, error: assessmentsError } = useAssessments(packetId, canViewAssessments);
  const completedBlindCount = blinded.filter(a => a.status === AssessmentStatus.COMPLETED).length;

  return {
    invitedCount,
    completedBlindCount,
    isLoading: isInvitationsLoading || isAssessmentsLoading,
    error: invitationsError || assessmentsError,
  };
} 